import React, { Component } from 'react'
import { ReactComponent as Logo } from './logo.svg';
import {Link} from 'react-router-dom';
import '../SideDrawer/DrawerToggleButton';
import './Header.css';
import DrawerToggleButton from '../SideDrawer/DrawerToggleButton';

export default class Header extends Component {
    render() {
        return (
        <div className="NavContainer">
            <div className="nav-item-bar">
                <Link to="/" className="logo-container">
                    {/* Logo is an actual React component */}
                    <Logo className="Logo"/>
                </Link>
                <div className="nav-container toolbar_navigation-items">
                    {/* <Link className="nav" to="/about">About</Link> */}
                    {/* <Link className="nav" to="/bootcamp">Bootcamp</Link> */}
                    {/* <Link className="nav" to="/findamentor">Find a mentor</Link> */}
                    {/* <Link className="nav" to="/joininus">Join in us</Link> */}
                    <Link className="nav loginbutton" to="/signin">Sign In</Link>
                    {/* <Link className="nav loginbutton" to="/test">Test secret page</Link> */}
                </div>
                {/* <div className="toolbar_navigation-button">
                    <DrawerToggleButton click={this.props.drawerToggleClickHandler}/>
                </div> */}
            </div>
        </div>
        )
    }
}
